import request from 'src/api'
import deleteRecord from 'src/deleteRecord'
import { addToast } from 'src/toasts'
import { lockButton, unlockButton, hideModalKeepLoader } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { assignPresent, camelize } from 'src/misc'
import initDatatableChrome from 'src/datatableChrome'
import onIndexRefresh from 'src/indexRefresh'

export default () => {
  // set dropdown values from local storage
  const usersIndexSelectRole = localStorage.getItem("usersIndexSelectRole")
  if (usersIndexSelectRole) {
    $("#select-role").val(usersIndexSelectRole)
  }
  const usersIndexSelectBu = localStorage.getItem("usersIndexSelectBu")
  if (usersIndexSelectBu) {
    $("#select-bu").val(usersIndexSelectBu)
  }

	// datatable init
  let usersDatatable = $('#users-datatable').DataTable({
    "language": {
      url: "/datatable_i18n"
    },
    "pageLength": (localStorage.getItem('usersIndexPageLength') || 25),
    "processing": true,
    // TODO.md F-123. A control COLUMN, not Responsive's default inline control. `'inline'` puts the expand
    // control in the FIRST cell — the same cell as the record's own link — so at phone width the two shared
    // one tap target and tapping the arrow opened the record. `target: 0` is the column added by
    // `shared/_datatable_control_th`.
    // ⚠️ The `dtr-control` className below is NOT optional: `Responsive._controlClass` (dataTables.responsive.js:674,
    // v2.5.1) runs its body only when `details.type === 'inline'`, so under `'column'` nothing adds it.
    // 🚨 **TODO.md F-123 follow-up. An EXPLICIT sort, because the control column silently removed it.**
    // DataTables' default is `aaSorting: [[0, 'asc']]` (`jquery.dataTables.js:10285`) and none of these
    // packs set `order`, so inserting the non-orderable control column at index 0 made the request carry
    // `order[0][column]=0`. `_fnSortFlatten` does not filter on `bSortable`, `ajax-datatables-rails` adds a
    // sort clause only `if column.orderable?` (`orm/active_record.rb:15`), and the resulting
    // `order(Arel.sql(''))` is dropped by Rails 8.1's `compact_blank` — verified:
    // `Customer.order(Arel.sql("")).limit(25).to_sql` has no ORDER BY at all.
    // ⚠️ **The lost alphabetical default was the visible half; the unstable paging was the dangerous one** —
    // server-side `LIMIT/OFFSET` with no ORDER BY can repeat or skip rows between pages.
    // 📌 Found by `/code-review` after the branch had already merged, which is why `spec/config/
    // datatable_responsive_spec.rb` now asserts an explicit non-zero `order` as part of the same rule.
    "order": [[1, "asc"]],
    "responsive": { "details": { "type": "column", "target": 0 } },
    "serverSide": true,
    "ajax": {
      "url": $('#users-datatable').data('source'),
      "data": function (d) {
        assignPresent(d, { role: $('#select-role').val(), bu: $('#select-bu').val() })
      }
    },
    "columns": [
      { "data": "control", "orderable": false, "searchable": false, "className": "dtr-control" },
      { "data": "first_name" },
      { "data": "last_name" },
      { "data": "phone" },
      { "data": "email" },
      { "data": "role" },
      { "data": "title" },
      { "data": "company" },
      { "data": "business_units" },
      { "data": "sign_in_count" },
      { "data": "current_sign_in_at" },
      { "data": "actions", "orderable": false, "className": "all" }
    ],
    initComplete(settings, json) {
      initDatatableChrome('users-datatable')
  	}
  })

  // T-102 / T-108 / U-48: reload this page's table when a save says so. The `off()`/`on()` pair and
  // `resetPaging: false` live in `src/indexRefresh` — five packs carried a copy of both.
  onIndexRefresh('usersIndex', usersDatatable)

  $('#content').on('change', "[name='users-datatable_length']", function() {
    localStorage.setItem('usersIndexPageLength', $(this).val())
  })

  $('#content').on('change', '#select-role, #select-bu', function() {
    localStorage.setItem(camelize('users-index-' + $(this).attr('id')), $(this).val())
    usersDatatable.ajax.reload()
  })

  $('.clear-button').on('click', function() {
    $('.clear-button').addClass('d-none')
    usersDatatable.search('').draw()
  })

  $('#content').on('click', '#add_user', function() {
    lockButton('#add_user')
    offcanvasRight.show()
    $.getScript('/users/new')
  })

  $('#mainModal').on('click', '#confirmDelete', function(event) {
    $(this).blur()

    if ($("body.users.index").length) {
      lockButton('#confirmDelete')
      let params = $('#confirmDelete').data('id')
      let p = ''
      if ($('#transferCustomers').length) {
        p += '?new_customer_id=' + $('#transferCustomers').val()
      }
      if ($('#transferEvents').length) {
        if (p.length > 0) {
          p += '&'
        } else {
          p += '?'
        }
        p += 'new_event_id=' + $('#transferEvents').val()
      }
      params += p
      
      // T-111: `deleteRecord` clears `dirty` before the close below — see F-148.
      deleteRecord(`/users/${params}`)
        .then(res => {
          addToast(res.body.success, 'notice')
          usersDatatable.ajax.reload()
          mainModal.hide()
          $('#offcanvasRight .btn-close').click()
        })
        .catch(err => {
          handleErrors(err, '#confirmDelete')
        })
    }
  })

  $('#content').on('click', '.delete-user', function() {
    const btn = this
    lockButton(btn)
    const id = $(btn).data('id')
    $.getScript('/users/' + id + '/delete_modal')
      .then(() => unlockButton(btn))
      .catch(err => handleErrors(err, btn))
  })

  $('#content').on('click', '.transfer-user-data', function() {
    const btn = this
    lockButton(btn)
    const id = $(btn).data('id')
    const buId = $(btn).data('bu_id')
    let url = '/users/' + id + '/transfer_modal'
    if (buId) url += '?bu_id=' + buId
    $.getScript(url)
      .then(() => unlockButton(btn))
      .catch(err => handleErrors(err, btn))
  })

  $('#mainModal').on('click', '#confirmTransferUserData', function(event) {
    const customer = $('#transfer-user-data-customers').is(':checked')
    const qualityControls = $('#transfer-user-data-quality-controls').is(':checked')

    if (customer || qualityControls) {
      lockButton('#confirmTransferUserData')

      let params = '?user_id=' + $(this).data('id')
      params += '&new_user_id=' + $('#transfer-user-data-user-select').val()
      if (customer) {
        params += '&customers=true'
      }
      if (qualityControls) {
        params += '&quality_controls=true'
      }
      
      request.post('/move_user_data' + params)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .then(res => {
          // Moving a user's data can take a while: keep the loader up for the whole wait, and
          // return the poll so the unlock below -- which releases it -- waits for the job.
          hideModalKeepLoader()
          return waitForJob(res.body.jobId, { intervalMs: 1000, timeoutMs: 120000 })
            .then(({ result }) => {
              if (result === 1) {
                addToast(I18n.t('move_user_data.success'), 'notice')
              }
            })
            .catch(err => handleErrors(err, null))
        })
        .catch(err => {
          handleErrors(err, '#confirmTransferUserData')
        })
        .finally(() => unlockButton('#confirmTransferUserData'))
    } else {
      addToast(I18n.t("errors.no_transfer_data"), 'alert')
    }
  })

  // U-23: release a Devise :lockable lock before its 30 minutes are up, for the office to use when the
  // locked person phones. Delegated from #offcanvasRight because the panel holding the button is replaced
  // wholesale by edit.js.erb — a handler bound to #unlock-user itself would die on the first re-render.
  $('#offcanvasRight').on('click', '#unlock-user', function() {
    const btn = this
    lockButton(btn)
    const id = $(btn).data('id')
    request.put(`/users/${id}/unlock`)
      .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      .accept('json')
      .then(res => {
        addToast(res.body.success, 'notice')
        // Re-fetch the panel rather than hiding the banner here: `access_locked?` is the server's answer,
        // and this way the one that renders it is the one that decides.
        return $.getScript(`/users/${id}/edit`).then(() => unlockButton(btn))
      })
      .catch(err => handleErrors(err, btn))
  })
}
